import React, { Component } from 'react';

import { 
	CheckboxMolecule,
	RadioMolecule,
	RangeMolecule,
	TableMonthsOfYear,
	LocationInput,
} from "../../molecules";
import {
	RadioWithOther
} from "../";

import {
	TextAreaInput,
	TextInput,
	Button,
	MaterialIcon
} from "../../atoms";

export class SwapForm extends Component {

	constructor(props) {
		super(props);
		this.state ={
			steps: Object.keys(props.subcategory.steps).length,
			step: "1"
		};
		this.nextAction = this.nextAction.bind(this);
		this.prevAction = this.prevAction.bind(this);
		this.isIE = !!document.documentMode;
	}

	componentWillUpdate(nextProps, nextState) {
		if(nextProps.subcategory.id !== this.props.subcategory.id)
			this.setState({step: "1"});
	}

	renderFormItem() {
		const step					= this.props.subcategory.steps[this.state.step];
		const values				= this.props.values;
		const changeAction	= this.props.changeAction;
		
		const handleChangeInputText 				= e => this.props.handleChangeInputText(e, step.id, changeAction, values);
		const handleChangeInputRange 				= e => this.props.handleChangeInputRange(e, step.id, changeAction, values);
		const handleChangeInputSpecialRange = e => this.props.handleChangeInputSpecialRange(e, step.id, changeAction, values);
		const handleChangeInputRadio				= e => this.props.handleChangeInputRadio(e, step.id, changeAction, values);
		const handleChangeInputCheckbox			= e => this.props.handleChangeInputCheckbox(e, step.id, changeAction, values);
		const handleChangeInputTextTable		= e => this.props.handleChangeInputTextTable(e, step.id, changeAction, values);
		const handleChangeInputLocation			= e => this.props.handleChangeInputLocation(e, step.id, changeAction, values);
		const handleChangeInputTextDinamic	= e => this.props.handleChangeInputTextDinamic(e, step.id, changeAction, values);
		const handleChangeInputRadioDinamic	= e => this.props.handleChangeInputRadioDinamic(e, step.id, changeAction, values);

		switch(step.type) {
			case "tableYear"							: return this.renderTableYear(step, values[step.id], handleChangeInputTextTable);
			case "rangeInput"							: return this.renderRangeInput(step, values[step.id], handleChangeInputRange);
			case "textArea"								: return this.renderTextAreaInput(step, values[step.id], handleChangeInputText);
			case "radio"									: return this.renderRadioInput(step, values[step.id], handleChangeInputRadio);
			case "textInput"							: return this.renderTextInput(step, values[step.id], handleChangeInputText);
			case "checkbox"								: return this.renderCheckBox(step, values[step.id], handleChangeInputCheckbox);
			case "location"								: return this.renderLocation(step, values, handleChangeInputLocation);
			case "specialRangeInput"			: return this.specialRangeInput(step, values, handleChangeInputSpecialRange);
			case "radioWithOther"					: return this.renderRadioWithOther(step, values[step.id], handleChangeInputRadio);
			case "dinamic"								: return this.renderDinamic(step, values, handleChangeInputTextDinamic);
			case "radioWithOtherDinamic": return this.renderDinamicRadioWithOther(step, values, handleChangeInputRadioDinamic);
		}
	}

	renderDinamicRadioWithOther(step, values, handleChangeInputTextDinamic) {
		return values.values.map((option, i) =>
			<RadioWithOther
				changeActionToRadio={handleChangeInputTextDinamic}
				id={step.id + "#" + values.values[i][step.id]}
				name={step.id+"#"+i}
				options={step.options}
				value={values.values[i][step.id] || ""}
				align="left"
				label={option["1"]}
			/>
		);
	}
	
	renderDinamic(step, values, handleChange) {
		return values.values.map((option, i) =>
			<TextInput label={option["1"]} id={i} name={step.id} value={option[step.id] || ""} changeAction={handleChange} />
		);
	}

	renderRadioWithOther(step, values, handleChangeToRadio) {
		return (
			<RadioWithOther
				changeActionToRadio={handleChangeToRadio}
				checked={values}
				id={step.id}
				options={step.options}
				value={values}
				align="left"
			/>
		);
	}
	
	renderRadioInput(step, values, handleChange) {
		return (
			<RadioMolecule 
				changeAction={handleChange}
				checked={values}
				id={step.id}
				options={step.options}
				value={values}
				align={"left"}
			/>
		);
	}

	renderCheckBox(step, values, handleChange) {
		return (
			<CheckboxMolecule
				options={step.options}
				checks={values || []}
				changeAction={handleChange}
				label={""}
			/>
		);
	}

	renderLocation(step, values, handleChange) {
		return values.values.map((option, i) =>
			<LocationInput label={option["1"]} name={i} values={option[step.id] || {}} handleChange={handleChange} />
		);
	}

	renderTextInput(step, values, handleChange) {
		return step.options.map((option, i) =>
			<TextInput label={option.label} id={option.id} value={values[option.id] || ""} changeAction={handleChange} />
		);
	}

	renderTableYear(step, values, handleChange) {
		return step.options.map((option, i) => {
			
			const headers = ["Mês", ((new Date()).getFullYear())];
			option.obs ? headers.push("Observações") : null;
			
			return (
				<TableMonthsOfYear
					label={option.label}
					id={option.id}
					changeAction={handleChange}
					headers={headers} 
					values={values || {}} 
					label={option.label}
					obs={option.obs}
				/>
			);
		});
	}

	renderRangeInput( step, values, handleChange ) {
		return step.options.map((option, i) => 
			<RangeMolecule
				key={i}
				label={option.label}
				value={values ? values[option.id] : 0}
				id={option.id}
				min={option.minRange}
				max={option.maxRange}
				changeAction={handleChange}
				mask={option.mask}
			/>
		);
	}
	
	specialRangeInput( step, values, handleChange ) {
		return step.options.map((option, i) => 
			<RangeMolecule
				key={i}
				label={option.label}
				value={values ? values[step.id][option.id] : 0}
				id={option.id}
				min={option.minRange}
				max={option.maxRange}
				changeAction={handleChange}
				mask={option.mask}
			/>
		);
	}
	renderTextAreaInput(step, values = {}, handleChange) {
		return step.options.map((option, i) =>
				<TextAreaInput key={i} label={option.label} value={values[option.id] || ""} id={option.id} changeAction={handleChange}/>
		);
	}

	nextAction() {
		const next = this.props.nextStepAction(false, this.props.values, this.state.step, this.props.doneStepAction, this.props.setDinamicValues);
		if(next != "end") return this.setState({step: next});

		this.setState({step: "1"});
		this.props.finishStep();
	}
	
	prevAction() {
		const next = this.props.nextStepAction(true, {}, this.state.step);
		if(next != "return") return this.setState({step: next});
		if (this.state.step == "1") return this.props.prevStepAction();
	}

	renderBoxExplanation() {
		return (
			<ul className="explanation-box">
				<li>Riscos podem ser subdivididos em 3 categorias:</li>
				<li>- Riscos Físicos: Escassez de água, enchentes, dentre outros;</li>
				<li>- Riscos Regulatórios: Cobrança pelo uso da água, padrões mais rígidos para lançamento de efluentes;</li>
				<li>- Riscos Reputacionais: Acidentes ambientais, multas ou demais fatores que podem comprometer a imagem e a reputação da empresa.</li>
			</ul>
		);
	}

	render() {
		$(document).ready(function(){
	    $('.tooltipped').tooltip({delay: 50});
		});
		const steps = this.props.subcategory;
		return (
			<div className={`swap-form ${this.isIE ? "ie-display flex -v -c -al-c" : "flex -v -c -al-c"}`}>
				<p className="question-label">{this.props.subcategory.steps[this.state.step].label}</p>
				<span>{steps.id == "businessPlanning" && this.state.step == "1-1" ? this.renderBoxExplanation() : ""}</span>
				<div className="form flex -v -c -al-c">
					{this.renderFormItem()}
				</div>
				<div className="actions">
					<a 
						className={`btn-floating btn-large waves-effect waves-light red button-floationg-return tooltipped ${this.state.step === "1" ? "disabledaa" : ""}`}
						onClick={this.prevAction}
						// title="Anterior"
						data-tooltip="Anterior"
						data-position="right"
						data-delay="50"
					>
						<MaterialIcon
							size="medium"
							type="arrow_back"
						/> 
					</a>
					<a 
						className="btn-floating btn-large waves-effect waves-light button-floationg-next tooltipped"
						onClick={() => this.nextAction()}
						data-delay="50"
						data-tooltip="Próximo"
						data-position="left"
					>
						<MaterialIcon
							size="medium"
							type="arrow_forward"
						/> 
					</a>
				</div>
				<a style={{position: "absolute", visibility: "hidden" }} tabIndex="-1" className="waves-effect waves-light btn modal-trigger" href="#doneFormAction"></a>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// src/components/common/SwapForm.js